module.exports = __webpack_public_path__ + "img/experiencia_vinculo_incorreto.70c07b3e.svg";